import axios from '@/axios'

export default {
	namespaced: true,

	state: {
		contracts: []
	},

	actions: {
		fetchAll({ commit }, { clientId, contractNo, date, isComplete, page, perPage } = {}) {
			return axios.get('/contract', {
				params: { clientId, contractNo, date, isComplete, sortByCreatedAt: true, nonDeleted: true, page, perPage }
			})
		},
		fetchStatistics({ commit }, { clientId, contractNo, date, isComplete, page, perPage } = {}) {
			return axios.get('/contract/SalesStatistics', {
				params: { clientId, contractNo, date, isComplete, sortByCreatedAt: true, nonDeleted: true, page, perPage }
			}).then(({ data }) => {
				return {
					saleBalances: data.saleBalances,
					totalSales: data.totalSales, 
				};
			})
		},
		fetchById({ commit }, { id }) {
			return axios.get(`/contract/${id}`);
		},
		fetchByNo({ commit }, { no }) {
			return axios.get('/contract/contractNo', { params: { contractNo: no } });
		},

		fetchContractMixes({ commit }, { contractMixId }) {
			return axios.get(`/contract/mixContract/${contractMixId}`)
		},

		create({ commit }, { contractNo, date, clientId, sale, items, deviationPercentage, ownerId }) {
			return axios.post('/contract', { contractNo, date, clientId, sale, items, deviationPercentage, ownerId });
		},

		update({ commit }, { id, contractNo, date, clientId, sale, items, deviationPercentage, ownerId }) {
			return axios.put(`/contract/${id}`, { contractNo, date, clientId, sale, items, deviationPercentage, ownerId });
		},

		changeStatus ({ commit }, { contractId, isCompleted }) {
			return axios.put(`contract/${contractId}/status`, {}, { params: { isCompleted } }).then((data) => {
				return data
			})
		},

		delete({ commit }, { id }) {
			return axios.delete(`/contract/${id}`);
		}
	},
}